import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';

const APP_TITLE = 'CAS';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styles: []
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {

  titulo: string;
  private routeSub: Subscription;

  constructor(private router: Router, private title: Title, private meta: Meta) {
    this.routeSub = this.getDataRoute()
    .subscribe(data => {
      this.titulo = data.titulo;
      // Si la ruta no define título (p. ej. /login tras expirar la sesión)
      // se conserva el nombre de la app; un título vacío hace que el navegador muestre la URL.
      this.title.setTitle(this.titulo ? `${this.titulo} | ${APP_TITLE}` : APP_TITLE);

      const metaTag: MetaDefinition = {
        name: 'description',
        content: this.titulo || APP_TITLE
      }
      this.meta.updateTag(metaTag);
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    this.title.setTitle(APP_TITLE);
  }

  getDataRoute(){
    return this.router.events
    .pipe(
      filter(evento => evento instanceof ActivationEnd),
      filter((evento: ActivationEnd) => evento.snapshot.firstChild === null),
      map((evento: ActivationEnd) => evento.snapshot.data)
    )
  };

}
